import { Component, Input } from '@angular/core';
import { NgForage } from 'ngforage';
import { IAlbum, Lightbox } from 'ngx-lightbox';
import AssetHelper from 'src/app/helpers/asset-helper';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import { KeysOfType } from 'src/app/helpers/utility-functions';
import Asset from 'src/app/model/asset';
import { ImmoTaskAsset } from 'src/app/model/immo-task/immo-task-asset';
import { ModalService } from 'src/app/services/modal.service';
import { SnackService } from 'src/app/services/snack.service';
import { ImmoTaskEditable } from '../service/get-immo-task-for-edit/immo-task-for-edit';
import { FileHelper } from '../../../../../helpers/file-helper';

@Component({
  selector: 'immo-task-asset-uploader',
  templateUrl: './immo-task-asset-uploader.component.html',
  styleUrls: ['./immo-task-asset-uploader.component.scss'],
})
export class ImmoTaskAssetUploader {
  @Input()
  task: ImmoTaskEditable;

  @Input()
  label: string = '+ Foto opladen';

  @Input()
  onlineAssetsProp: KeysOfType<ImmoTaskEditable, ImmoTaskAsset[]>;

  @Input()
  offlineAssetsProp: KeysOfType<ImmoTaskEditable, Asset[]>;

  isImage = FileHelper.isImage;

  constructor(
    private modalService: ModalService,
    private snackService: SnackService,
    private ngForage: NgForage,
    private _lightbox: Lightbox
  ) {}

  removeOnlineFile(index: number): void {
    this.modalService.confirmDialog(
      'Foto verwijderen',
      'Bent u zeker dat u deze foto wilt verwijderen?',
      () => {
        this.task[this.onlineAssetsProp].splice(index, 1);
        this.snackService.showSuccess(
          'Foto zal verwijderd worden tijdens opslaan'
        );
      }
    );
  }

  removeOfflineFile(item: Asset, index: number) {
    this.modalService.confirmDialog(
      'Foto verwijderen',
      'Bent u zeker dat u deze foto wilt verwijderen?',
      () => {
        this.task[this.offlineAssetsProp].splice(index, 1);
        this.ngForage.removeItem(
          AssetHelper.getStorageKeyFor(item.localFileUuid)
        );
        this.snackService.showSuccess('Foto succesvol verwijderd');
      }
    );
  }

  onAssetsAdded(assets: Asset[]): void {
    if (this.task[this.offlineAssetsProp] == null) {
      this.task[this.offlineAssetsProp] = [];
    }
    assets.forEach((a) => this.task[this.offlineAssetsProp].push(a));
    this.snackService.showSuccess(
      'Foto zal toegevoegd worden zodra deze taak wordt opgeslagen'
    );
  }

  openLightbox(index: number, offlineClicked: boolean): void {
    if (
      !CollectionHelper.isPopulated(this.task[this.onlineAssetsProp]) &&
      !CollectionHelper.isPopulated(this.task[this.offlineAssetsProp])
    ) {
      return;
    }

    const album: IAlbum[] = [];

    if (CollectionHelper.isPopulated(this.task[this.onlineAssetsProp])) {
      this.task[this.onlineAssetsProp].forEach((ta) => {
        album.push({
          src: `/api/assets/${ta.asset.uuid}`,
          thumb: `/api/assets/${ta.asset.uuid}`,
        });
      });
    }
    if (CollectionHelper.isPopulated(this.task[this.offlineAssetsProp])) {
      this.task[this.offlineAssetsProp].forEach((a) => {
        album.push({
          src: <string>a.localSafeUrl,
          thumb: <string>a.localSafeUrl,
        });
      });
    }

    const toOpenIndex =
      offlineClicked &&
      CollectionHelper.isPopulated(this.task[this.onlineAssetsProp])
        ? index + this.task[this.onlineAssetsProp].length
        : index;

    this._lightbox.open(album, toOpenIndex);
  }
}
